import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/data/siteData";
import { HOME } from "@/constants/testIds";

export default function FAQSection() {
  return (
    <section id="faq" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <p className="overline">Domande frequenti</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            Le domande che ci vengono poste più spesso.
          </h2>
        </div>

        <div className="mt-14">
          <Accordion type="single" collapsible className="w-full">
            {FAQ.map((f, i) => (
              <AccordionItem
                value={`faq-${i}`}
                key={i}
                className="border-b border-gray-100 last:border-0"
              >
                <AccordionTrigger
                  data-testid={HOME.faqTrigger(i)}
                  className="text-left py-6 font-serif text-lg md:text-xl text-[#0B4A5A] hover:no-underline hover:text-[#0D5E73] group"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-gray-600 leading-relaxed text-[15px]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
